import { DashboardComponentGroupReportOptions } from "./DashboardReportOptions";

export enum DashboardLayoutType {
  VERTICAL = "VERTICAL",
  HORIZONTAL_FLEX = "HORIZONTAL_FLEX",
  GRID = "GRID",
}
export type LayoutConfigType = {
  [DashboardLayoutType.VERTICAL]?: {
    width?: number;
    height?: number | string;
  };
  [DashboardLayoutType.HORIZONTAL_FLEX]?: {
    width?: number;
    height?: number | string;
  };
  [DashboardLayoutType.GRID]?: {
    width?: number;
    height?: number | string;
    x: number;
    y: number;
  };
};

export interface IDashboardComponent {
  id: string;
  title: string;
  titleSize: string;
  titleAlign: string;
  type: DashboardComponentType;
  config: any;
  layout: LayoutConfigType;
  collapsable: boolean;
  defaultCollapsed?: boolean;
  hideHeader?: boolean;
  reportOptions?: DashboardComponentGroupReportOptions;
}

export const COMPONENT_TYPES = [
  "SparkLineValueIndicator",
  "SparkLineAdvanced",
  "DatasetCollapseDataTable",
  "MeasurementDeviceTableAgreg",
  "ProductTemplateTable",
  "DatasetLineChart",
  "DatasetHistogramChart",
  "DatasetBarChart",
  "GridHeatMap",
  "DatasetScatterChart",
  "DatasetPieChart",
  "DatasetSankeyChart",
  "DataInputOutputTable",
  "Scada",
  "DatasetToggleTable",
  "DatasetSetpointTable",
  "CalendarHeatmap",
  "CameraStream",
  "DatasetTable",
  "ConfidenceIntervalLineChart",
  "DatasetDataInputTable",
  "UniversalDatasetTable",
  "EapsmLicenceManager",
  "FreeText",
  "GranttChart",
  "GeneratedReportTable",
  "AlertFan",
  "PIDController",
  "DashboardRedirectButton",
  "Separator",
  "InstantJobEnqueueConfigurator",
  "DevicesMap",
  "LastKnownValueTimeMoment",
  "WeatherMonitoring",
  "DatasetStatusMonitoring",
  "ProductTemplateBubbleChart",
  "DialIndicator",
  "DashboardComponentConfigurator",
  "DashboardFragment",
  "ProductTemplateConfiguratorJson",
  "DataWindowChart",
  "ProductTemplateDataManagerFragment",
  "CompanyContextSelect",
  "EasasGlobalFragment",
  "EasasMain",
  "ScheduleBookingPage",
  "ScheduledAirflowTaskConfigPage",
  "DatasetPage",
  "DashboardReportsPage",
  "UserSessionStatsPage",
  "CompanyFilesPage",
  "MeasurementDeviceManagementPage",
  "ReactExample",
  "FailingComponentTest",
  "DevSandbox",
  "ObjectDataset",
  "ProductItemMap",
  "ValueChangeIndicator",
  "ProductTemplateBarChart",
  "PeriodicBarChart",
  "ProductTemplateBarChart"
] as const;

export type DashboardComponentType = (typeof COMPONENT_TYPES)[number];

export interface OldDashboardComponent {
  TYPE: string;
  id: string;
  width: number;
  title: string;
  componentType: string;
  jsonConfig: string;
}
